import { Component,Inject, OnInit } from '@angular/core';
import { Subscription} from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-user-admin-account',
  templateUrl: './user-admin-account.component.html',
  styleUrls: ['./user-admin-account.component.scss']
})
export class UserAdminAccountComponent implements OnInit {


  public searchAdd:string = "";

  public selectedThing = [];

  salesOrgL2Data = {};

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<UserAdminAccountComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.initSalesOrgL2Data();
  }

  initSalesOrgL2Data() {
    if (this.data.type === 'region') {
      this.data.data.forEach(item => {
        this.salesOrgL2Data[item.name] = JSON.parse(JSON.stringify(item.subregions));
      });
    }
  }

  compareFunction(o1,o2){
    return o1.id===o2.id;
  }

  handleChange(event: any) {
    const { option: { value, selected } } = event;
    if (this.data.type === 'region') {
      let regionData = null;
      let currentOptionData = null;
      for (const item of this.data.data) {
        if (item.id === value) {
          regionData = item;
          currentOptionData = item;
          break;
        } else {
          for (const sub of item.subregions) {
            if (sub.id === value) {
              regionData = item;
              currentOptionData = sub;
              break;
            }
          }
        }
      }

      if (currentOptionData && regionData) {
        const { subregions } = regionData;
        if (currentOptionData.type === 'region') {
          if (selected) {
            let arr = [];
            subregions.forEach(itm => {
              if (!this.selectedThing.includes(itm.id)) {
                arr.push(itm.id);
              }
            });
            this.selectedThing = this.selectedThing.concat(arr);
          } else {
            this.selectedThing = this.selectedThing.filter(itm => {
              const isSubItem = subregions.find(sub => sub.id === itm);
              return isSubItem ? false : true;
            });
          }
        } else {
          const allSelected = subregions.every(itm => this.selectedThing.includes(itm.id));
          if (allSelected) {
            this.selectedThing = this.selectedThing.concat([regionData.id]);
          } else {
            this.selectedThing = this.selectedThing.filter(itm => itm !== regionData.id);
          }
        }
      }
    }
  }

  getData(){
    if(this.searchAdd==""){
      return this.data.data;
    } else {

      let fnd = this.searchAdd.toLowerCase().trim();
      if (this.data.type === 'region') {
        return this.data.data.filter(region => { 
          const subRegions = region.subregions.filter(sub => {
            return sub.name && sub.name.toLowerCase().includes(fnd);
          });
          return subRegions.length;
        });
      } else {
        return this.data.data.filter(x => {    
          let rtn = false;
          ["name","short","region","code","bdmname","sfid","value","label"].forEach( y => {              
            if(x[y]!=null && x[y].toLowerCase().includes(fnd)) {
              rtn = true;
            }
          })
          return rtn;
        });                                    
      }
    }
  }

  getSubData(region) {
    if(this.searchAdd == ''){
      return this.salesOrgL2Data[region];
    } else {
      let fnd = this.searchAdd.toLowerCase().trim();
      return this.salesOrgL2Data[region].filter(sub => { 
        return sub.name && sub.name.toLowerCase().includes(fnd);
      });
    }
  }

  getAccessText(){
    if(this.data.accessType=="W") return "Read/Write";
    if(this.data.accessType=="R") return "Read";
    if(this.data.accessType=="N") return "No Access";
    return "";
  }

  ok():void {
    let selectedOptions = [];
    if (this.data.type === 'region') {
      this.data.data.forEach(item => {
        if (this.selectedThing.includes(item.id)) {
          selectedOptions.push(item.id);
        } else {
          item.subregions.forEach(sub => {
            if (this.selectedThing.includes(sub.id)) {
              selectedOptions.push(sub.id);
            }
          });
        }
      });
    } else {
      selectedOptions = this.selectedThing;
    }
    this.dialogRef.close({selected: selectedOptions,accessType:this.data.accessType});
  }

  cancel(){
    this.dialogRef.close("cancel");
  }

}
